<template>
    <section class="tekst light purple">
        <circles-layout></circles-layout>
        <h1>Een groot compliment</h1>
        <p>Het afgelopen jaar laat zien hoe crisisbestendig we zijn. Ook in 2021 &mdash; wederom een coronajaar &mdash; vroegen we veel van de inzet en flexibiliteit van onze leerlingen, studenten en medewerkers. Terugkijkend zijn wij ongelofelijk trots op hoe we samen de coronacrisis het hoofd boden. En op hoe we nu samen de impact van de crisis op het onderwijs aanpakken. <br/>Dat verdient een groot compliment!</p>
    </section>
</template>

<style lang="scss" scoped>
    // see /static/scss/pages/_tekst.scss
</style>

<script>
    import Circles from '@/app/components/circles';
    export default {
        name: 'OntwikkelingTrots',
        meta: {
            title: 'OntwikkelingTrots',
            color: '#a5147e'
        },
        components: {
            'circles-layout': Circles
        },
        methods: {
            focus()
            {
            }
        }
    };
</script>
